import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type MyProfileState = {
    isOpen: boolean;
    headerText: string;
    closeOnBackdropClick: boolean;
}

const initialState: MyProfileState = {
    isOpen: false,
    headerText: "",
    closeOnBackdropClick: false,
}

const myProfileSlice = createSlice({
    name: "myProfile",
    initialState,
    reducers: {
        setIsOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setHeaderText: (state, action: PayloadAction<string>) => {
            state.headerText = action.payload;
        },
        setCloseOnBackdropClick: (state, action: PayloadAction<MyProfileState>) => {
            state.closeOnBackdropClick = action.payload.closeOnBackdropClick;
        },
        reset: (state) => {
            state = initialState;
        },
    },
});

export const {
    setIsOpen,
    setHeaderText,
    reset,
} = myProfileSlice.actions;
const myProfileReducer = myProfileSlice.reducer;
export default myProfileReducer;
